import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import EventPage from "@/pages/EventPage";
import Checkout from "@/pages/Checkout";
import BookingPage from "@/pages/BookingPage";
import FindBooking from "@/pages/FindBooking";
import Embed from "@/pages/Embed";
import Admin from "@/pages/Admin";
import StoryPage from "@/pages/StoryPage";
import ClubsPage from "@/pages/ClubsPage";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

const Shell = () => {
  const { pathname, hash } = useLocation();
  const bare = pathname.startsWith("/embed");
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); }
  }, [pathname, hash]);
  return (
    <div className="flex min-h-screen flex-col">
      {!bare && <SiteHeader />}
      <div className="flex-1">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/events/:slug" element={<EventPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/booking" element={<FindBooking />} />
        <Route path="/booking/:code" element={<BookingPage />} />
        <Route path="/embed" element={<Embed />} />
        <Route path="/embed/:slug" element={<Embed />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/the-bourbon-king" element={<StoryPage />} />
        <Route path="/bourbon-clubs" element={<ClubsPage />} />
      </Routes>
      </div>
      {!bare && <SiteFooter />}
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster theme="light" position="top-center" richColors />
    </div>
  );
}

export default App;
